import { EventName } from '@lit/react';
import { BlocksDaterangepickerField } from 'blocks-nextjs/blocks-web-components/components/daterangepicker-field/daterangepicker-field';
import { BlocksCloseEvent, BlocksDateRangeEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatDaterangepickerField = createComponent({
  react: React,
  tagName: 'cat-daterangepicker-field',
  elementClass: BlocksDaterangepickerField,
  events: {
    onBlDateRangeChange: 'bl-date-range-change' as EventName<BlocksDateRangeEvent>,
    onBlDateRangeOpen: 'bl-date-range-open' as EventName<BlocksOpenEvent>,
    onBlDateRangeClose: 'bl-date-range-close' as EventName<BlocksCloseEvent>
  }
});
